import React, { useCallback } from 'react';
import { FIXED_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import {
	MENU_ID_APP_MARKETPLACE_DISCOVER,
	MENU_ID_APPS,
} from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useFormattedMessageAndIcon } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';
import MarketplaceIcon from '@atlaskit/icon/core/marketplace';
import AppsIcon from '@atlaskit/icon/core/apps';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

import { defineMessage } from '@atlassian/jira-intl';

const exploreMoreApps = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps',

	defaultMessage: 'Explore more apps',
	description: 'Label for "Explore more apps" link under the Apps menu of the global sidebar',
});

const pathToNavigate = '/jira/marketplace/discover';

export function ExploreMoreApps(): React.JSX.Element | null {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const tenantContext = useTenantContext();
	const { isAdmin, isSiteAdmin } = tenantContext;

	const Icon = fg('use-marketplace-icon') ? MarketplaceIcon : AppsIcon;
	const { formattedMessage, icon } = useFormattedMessageAndIcon(exploreMoreApps, Icon);

	const onClick = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), {
			action: 'clicked',
			actionSubject: 'navigationItem',
			actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_APPS],
			attributes: {
				level: LEVEL_ONE,
				componentType: FIXED_ITEM,
				itemId: 'exploreMoreApps',
			},
		});
	}, [createAnalyticsEvent]);

	const showExploreMoreApps =
		isAdmin || isSiteAdmin
			? expVal('emcee-discover', 'value', true)
			: expVal('enduser-emcee-discover', 'value', true);

	if (!showExploreMoreApps) {
		return null;
	}

	return (
		<Nav4MenuLinkItem
			elemBefore={icon}
			href={pathToNavigate}
			menuId={MENU_ID_APP_MARKETPLACE_DISCOVER}
			onClick={onClick}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
}
